<template>
  <div id="blockly" ref="blockly"></div>
</template>

<script>
import * as Blockly from 'blockly';

import 'blockly/blocks';
import 'blockly/python';

import * as En from 'blockly/msg/en';
Blockly.setLocale(En);

require('../assets/microbit_blocks/messages/en/messages.js');
require('../assets/microbit_blocks/blocks/microbit.js');
require('../assets/microbit_blocks/generators/python.js');
require('../assets/microbit_blocks/generators/microbit.js');
require('../assets/microbit_blocks/generators/buttons.js');
require('../assets/microbit_blocks/generators/accelerometer.js');
require('../assets/microbit_blocks/generators/compass.js');
require('../assets/microbit_blocks/generators/display.js');
require('../assets/microbit_blocks/generators/image.js');
require('../assets/microbit_blocks/generators/music.js');
require('../assets/microbit_blocks/generators/neopixel.js');
require('../assets/microbit_blocks/generators/pins.js');
require('../assets/microbit_blocks/generators/radio.js');
require('../assets/microbit_blocks/generators/speech.js');
require('../assets/microbit_blocks/generators/variables.js');
require('../assets/grove_blocks/blocks/grove.js');
require('../assets/grove_blocks/generators/grove.js');
require('../assets/js/blockly_override.js');


var FileSaver = require('file-saver');

export default {
  name: 'BlocklyEditor',
  props: {
    toolbox_xml:String,
    width:String,
    height:String,
    zoom:Number
  },
  data:function () {
    return {
      toolbox:Object,
      Blockly:Object,
      python_data:Object,
      z:0,
      xml: '',
      darkmode: true
    }
  },
  methods: {
    onBlocklyChanged() {
      let _xml = Blockly.Xml.domToPrettyText(Blockly.Xml.workspaceToDom(this.workspace));
      if (this.xml != _xml) {
        if (!this.blocking)
          this.$emit('changed', _xml);
        this.xml = _xml;
      }
    },
    getPython() {
      return Blockly.Python.workspaceToCode(this.workspace);
    },
    toggleDarkMode(b) {
      this.darkmode = b
      Array.from(document.getElementsByClassName('blocklySvg')).forEach(el=>el.style.backgroundColor=b?'#272822':'');
      Array.from(document.getElementsByClassName('blocklyToolboxDiv')).forEach(el=>el.style.backgroundColor=b?'#272822':'')
      Array.from(document.getElementsByClassName('blocklyFlyoutBackground')).
        concat(Array.from(document.getElementsByClassName('blocklyFlyoutBackgroundLight'))).
        forEach(el=>el.className.baseVal=b?'blocklyFlyoutBackground':'blocklyFlyoutBackgroundLight');
      Array.from(document.getElementsByClassName('blocklyFlyoutBackground')).
        concat(Array.from(document.getElementsByClassName('blocklyFlyoutBackgroundLight'))).
        forEach(el=>console.log(el));

    },
    save(file_name) {
      var blob = new Blob([Blockly.Xml.domToPrettyText(Blockly.Xml.workspaceToDom(this.workspace))], {type: "text/plain;charset=utf-8"});
      FileSaver.saveAs(blob, file_name);
    },
    async reload(toolbox_xml) {
      if (typeof(this.workspace) !== 'undefined') this.workspace.dispose();
      this.workspace = Blockly.inject('blockly', {
        toolbox: this.toolbox_xml,
        grid: {
          spacing: 32,
          length: 1,
          colour: '#777',
          snap: true
        },
        trashcan: true,
        oneBasedIndex: false,
        hasScrollbars: true,
        zoom: {
          controls: true,
          wheel: true,
          startScale: 1.0,
          maxScale: 3,
          minScale: 0.3,
          scaleSpeed: 1.2
        }
      });
      Blockly.Python.init(this.workspace);
      this.workspace.addChangeListener(this.onBlocklyChanged);
      this.toggleDarkMode(this.darkmode);
    },
    async load(xml) {
      //console.log('load', xml);
      let dom;
      try {
        dom = Blockly.Xml.textToDom(xml)
      } catch (e) {
        this.$emit('prompt', 'XML did not produce a valid Blockly object.', 'error');
        return;
      }
      this.xml = xml;
      this.workspace.clear();
      await this.reload(this.toolbox_xml);
      this.resize();
      Blockly.Xml.domToWorkspace(dom, this.workspace);
      //console.log('load', Blockly.Xml.domToPrettyText(Blockly.Xml.workspaceToDom(this.workspace)));
    },
    resize() {
      let that = this;
      window.requestAnimationFrame(function() {
        Blockly.svgResize(that.workspace);
        that.workspace.markFocused();
        that.workspace.beginCanvasTransition();
        that.workspace.scrollCenter();
        setTimeout(function() {
          that.workspace.endCanvasTransition();
        }, 500);
      });
    },
    clear() {
      this.workspace.clear();
      this.onBlocklyChanged();
    }
  },
  watch: {
    zoom: function (zoom) {
      if (zoom > this.z) this.workspace.zoomCenter(+1);
      else this.workspace.zoomCenter(-1);
      this.z = zoom;
    },
    toolbox_xml: function (toolbox_xml) {
      this.reload(toolbox_xml);
    },
    height:function() {
      this.resize();
      this.workspace.setScale(this.workspace.options.zoomOptions.startScale);
      this.workspace.scrollCenter();
    },
    width:function() {
      this.resize();
    }
  },
  mounted () {
    console.log(Blockly)
    Blockly.Python.INDENT = '\t';
    this.reload(Blockly.Xml.textToDom('<xml id="blockly-toolbox" style="display: none"></xml>'));
    this.$emit('loaded');
  }
}
</script>

<style>
#blockly {
  height: 100%;
  width: 100%;
}
/* Entire Blockly area, Toolbox dranw on top */
.blocklySvg {
  border-width: 0 !important;
}

.blocklyFlyout {
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  overflow: hidden !important;
  z-index: 2;
}

/* Toolbox second column with blocks*/
.blocklyFlyoutBackground {
  fill: rgb(47, 49, 41) !important;
  fill-opacity: 0.7 !important;
  border: solid #272822 1px !important;
  -webkit-border-radius: 0px 4px 4px 0px !important;
  -moz-border-radius: 0px 4px 4px 0px !important;
  border-radius: 0px 4px 4px 0px !important;
}

.blocklyFlyoutBackgroundLight {
  fill: #FFF;
  fill-opacity: 1.0 !important;
  border: solid #272822 1px !important;
  -webkit-border-radius: 0px 4px 4px 0px !important;
  -moz-border-radius: 0px 4px 4px 0px !important;
  border-radius: 0px 4px 4px 0px !important;
}

/* Toolbox */
.blocklyToolboxDiv {
  border-color: #e0e0e0 !important;
  border-width: 0px 1px 0px 0px !important;
  -webkit-border-radius: 0px 4px 4px 0px !important;
  -moz-border-radius: 4px 4px 0px 0px !important;
  border-radius: 0px 4px 4px 0px !important;
  border: none !important;
  margin: 0px !important;
  padding: 0px 0px 0px 0px !important;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  overflow: hidden !important;
  z-index: 5;
}

.blocklyTreeRoot {
  background: none !important;
  border: none !important;
  margin: 0px 0px 0px 0px !important;
  padding: 0px 1px !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.blocklyTreeRow {
  margin: 0px 0px !important;
  padding: 7px 16px 7px 0px !important;
  box-sizing: content-box !important;
}

.blocklyTreeSelected {
  color: #000 !important;
}

.blocklyTreeRow:not(.blocklyTreeSelected):hover {
  background-color: #fec336 !important;  /* ecu yellow */
  color: #000 !important;
}

.blocklyTreeLabel {
}

.blocklyTreeIconClosedLtr {
    background-position: -32px -16px;
}

.blocklyTreeIconOpen {
    background-position: -32px -16px;
}

.blocklyTreeSeparator{
  padding: 0px !important;
  margin: 0px !important;
  border: solid #272822 1px !important;
}

/* Blockly scrollbars */
.blocklyScrollbarHandle {
  fill: #E6DB74 !important;
  fill-opacity: 1.0 !important;
  rx: 0px;
  ry: 0px;
}

.blocklyScrollbarVertical .blocklyScrollbarHandle {
  width: 10px;
}

.blocklyScrollbarHorizontal .blocklyScrollbarHandle {
  height: 10px;
}

.blocklyScrollbarBackground {
  stroke-width: 0px !important;
  fill: none !important;
}

.blocklyMainBackground {
  stroke-width: 0;
}

.blocklyPathLight {
  stroke: none;
}

.blocklyHtmlInput {
  background-color: #FFF;
}
</style>